"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.KHInputAxisDerived = void 0;
const KHInputAxis_1 = require("./KHInputAxis");
class KHInputAxisDerived extends KHInputAxis_1.KHInputAxis {
    constructor(inputSet) {
        super();
        if (inputSet) {
            inputSet.addInput(this);
        }
    }
}
exports.KHInputAxisDerived = KHInputAxisDerived;
